export default __webpack_public_path__ + "static/media/chrome-icon-color.aeb91b03.png";